import * as React from 'react';

import ProjectTypeNav from '../../components/ProjectTypeNav';
import { ProjectTypeRenderer } from '../../models/ProjectType';
import styled from '../../theme';
import Footer from '../../components/Footer';
import HeaderScrollNotification from '../../components/HeaderScrollNotification';

import Nav from './Nav';
import ProjectList from './ProjectList';
import Header from './Header';
import Meta from './Meta';
import GlobalAboutLink from './GlobalAboutLink';

const ContentContainer = styled.div`
  position: relative;
`;
class Project extends React.PureComponent<{
  projectType: string;
  projectSlug: string;
  archived: boolean;
}> {
  render() {
    return (
      <>
        <GlobalAboutLink />

        <ProjectTypeNav />

        <HeaderScrollNotification />

        <Header projectType={this.props.projectType} />

        <Meta projectType={this.props.projectType} />

        <ProjectTypeRenderer
          render={({ typeProjectsMap }) => {
            return (
              <ContentContainer>
                <ProjectList
                  typeProjectsMap={typeProjectsMap}
                  projectType={this.props.projectType}
                  archived={this.props.archived}
                />
                <Nav
                  typeProjectsMap={typeProjectsMap}
                  projectType={this.props.projectType}
                  archived={this.props.archived}
                />
              </ContentContainer>
            );
          }}
        />

        <Footer />
      </>
    );
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/scenes/Project/Project.tsx